/* ============================================================
   TAO WEARING — Currency selector (display only, new/update-safe).
   A dropdown picks a currency; the PRICE ITSELF is swapped to that currency
   in place (PDP + cards). Store currency (base) is the default and restores
   the original prices. Does NOT touch checkout. Choice persists (localStorage).
   Elements:
     [data-tao-cur-select]  <details> dropdown (JS fills options; trigger shows
                            [data-flag] + [data-code])
     [data-tao-price-el]    a price element with data-amount (+ optional
                            data-compare) in store-currency minor units
   Live rates from a free FX API (cached 12h).
   ============================================================ */
(function () {
  'use strict';
  if (window.__taoCurrency) return;
  window.__taoCurrency = true;

  var base = (window.TaoShopCurrency || 'USD').toUpperCase();
  var TARGETS = ['USD', 'EUR', 'GBP', 'AED', 'TRY'];
  var FLAGS = { USD: '🇺🇸', EUR: '🇪🇺', GBP: '🇬🇧', AED: '🇦🇪', TRY: '🇹🇷', SAR: '🇸🇦', KWD: '🇰🇼', QAR: '🇶🇦', BHD: '🇧🇭', OMR: '🇴🇲', CAD: '🇨🇦', AUD: '🇦🇺', JPY: '🇯🇵', CHF: '🇨🇭', INR: '🇮🇳' };
  var NAMES = { USD: 'US Dollar', EUR: 'Euro', GBP: 'British Pound', AED: 'UAE Dirham', TRY: 'Turkish Lira', SAR: 'Saudi Riyal', KWD: 'Kuwaiti Dinar', QAR: 'Qatari Riyal', BHD: 'Bahraini Dinar', OMR: 'Omani Rial', CAD: 'Canadian Dollar', AUD: 'Australian Dollar', JPY: 'Japanese Yen', CHF: 'Swiss Franc', INR: 'Indian Rupee' };
  // store currency first (default = original prices), then foreign currencies
  var CURRENCIES = [base].concat(TARGETS.filter(function (c) { return c !== base; }));
  var KEY = 'tao_cur';
  var TTL = 12 * 60 * 60 * 1000;

  var selectors = document.querySelectorAll('[data-tao-cur-select]');
  var priceEls = document.querySelectorAll('[data-tao-price-el]');
  if (!selectors.length && !priceEls.length) return;

  var selected = base;
  try { var saved = localStorage.getItem(KEY); if (saved && CURRENCIES.indexOf(saved) >= 0) selected = saved; } catch (e) {}

  // snapshot the original (store-currency) markup so we can restore it
  priceEls.forEach(function (el) { if (el._taoBase == null) el._taoBase = el.innerHTML; });

  function fmt(amount, cur) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: 2 }).format(amount); }
    catch (e) { return cur + ' ' + amount.toFixed(2); }
  }
  function flag(cur) { return FLAGS[cur] || ''; }

  function loadRates() {
    return new Promise(function (resolve) {
      var key = 'tao_fx_' + base;
      try {
        var c = JSON.parse(localStorage.getItem(key) || 'null');
        if (c && c.r && (Date.now() - c.t) < TTL) { resolve(c.r); return; }
      } catch (e) {}
      fetch('https://open.er-api.com/v6/latest/' + base)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var rates = (d && d.rates) ? d.rates : {};
          try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), r: rates })); } catch (e) {}
          resolve(rates);
        })
        .catch(function () { resolve({}); });
    });
  }

  loadRates().then(function (rates) {
    function applyTo(el) {
      if (el._taoBase == null) el._taoBase = el.innerHTML;
      var r = rates[selected];
      if (selected === base || !r) { el.innerHTML = el._taoBase; return; }
      var amt = parseFloat(el.getAttribute('data-amount')) || 0;
      var cmp = parseFloat(el.getAttribute('data-compare')) || 0;
      var html = '≈ ' + fmt(amt / 100 * r, selected);
      if (cmp > amt) html += ' <s>' + fmt(cmp / 100 * r, selected) + '</s>';
      el.innerHTML = html;
    }
    function applyAll() { priceEls.forEach(applyTo); }
    window.TaoApplyCurrency = applyTo;

    function refreshSelectors() {
      selectors.forEach(function (sel) {
        var fl = sel.querySelector('[data-flag]'); if (fl) fl.textContent = flag(selected);
        var cd = sel.querySelector('[data-code]'); if (cd) cd.textContent = selected;
        sel.querySelectorAll('[data-cur]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cur') === selected); });
      });
    }
    function setCurrency(cur) {
      if (CURRENCIES.indexOf(cur) < 0) return;
      selected = cur;
      try { localStorage.setItem(KEY, cur); } catch (e) {}
      selectors.forEach(function (sel) { sel.open = false; });
      refreshSelectors();
      applyAll();
    }

    selectors.forEach(function (sel) {
      var menu = sel.querySelector('[data-tao-cur-menu]');
      if (menu && !menu.children.length) {
        menu.innerHTML = CURRENCIES.map(function (cur) {
          return '<button type="button" class="tao-cur__opt" data-cur="' + cur + '">' +
            '<span class="tao-cur__opt-flag">' + flag(cur) + '</span>' +
            '<span class="tao-cur__opt-name">' + (NAMES[cur] || cur) + '</span>' +
            '<span class="tao-cur__opt-code">' + cur + '</span></button>';
        }).join('');
      }
      sel.querySelectorAll('[data-cur]').forEach(function (b) {
        b.addEventListener('click', function () { setCurrency(b.getAttribute('data-cur')); });
      });
    });

    // PDP variant change re-applies (tao-product also calls window.TaoApplyCurrency)
    document.addEventListener('tao:variant', function () { applyAll(); });

    document.addEventListener('click', function (e) {
      selectors.forEach(function (sel) { if (sel.open && !sel.contains(e.target)) sel.open = false; });
    });

    refreshSelectors();
    applyAll();
  });
})();
